export default "__VITE_ASSET__f70fa50e__"